import { Button, Flex, Image, Textarea } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";

import MicIcon from "../../../../../assets/Images/Mice-icon.svg"
import MuteIcon from "../../../../../assets/Images/Mute-Mice-icon.svg"
import { CustomToast } from "../../../../../components";
// interface IProps {
//     placeHolder: string,
//     setValue: (value: string) => void,
//     setAudioFile: (value: File | null) => void,
//     understoodText: string | null
// }

interface IProps {
    placeHolder: string;
    setValue: (value: string) => void;
    setAudioFile: (value: File | null) => void;
    understoodText: string | null;
}

export const SpeechToText = (props: IProps) => {
    const { text, listening, start, stop, setText, audioBlob, audioFile } = useSpeechToText();

    useEffect(() => {
        if (text !== null && text.length > 0) props.setValue(text);
        if (audioFile !== null) props.setAudioFile(audioFile);
    }, [text, audioFile]);

    // useEffect(() => {
    //     if (props.understoodText === null) setText("");
    // }, [props.understoodText]);

    useEffect(() => {
        setText(props.understoodText || "");
    }, [props.understoodText]);

    return (
        <Flex direction="column" width="100%">
            {/* <textarea
                value={text}
                onChange={(e) => setText(e.target.value)}
                rows={5}
                style={{ width: "100%" }}
                placeholder={props.placeHolder}
            /> */}


            <Textarea
                value={text}
                onChange={(e) => { setText(e.target.value); props.setValue(e.target.value); }}
                placeholder={props.placeHolder}
                minH="200px"
               
            />

            <Button maxW="150px"
                mt={4}
                bg={listening ? "#DC2626" : "#4048D6"}
                color="white"
                _hover={{ bg: listening ? "#B91C1C" : "#353CC4",}}
                borderRadius="8px"
                px={6}
                leftIcon={<Image src={listening ? MicIcon : MuteIcon} boxSize="18px" alt="Mic"/>}
                onClick={listening ? stop : start}
            >
                {listening ? "Click To Stop" : "Click To Speak"}
            </Button>
       </Flex>
    );
}

export const useSpeechToText = () => {
    const recognitionRef = useRef<any>(null);
    const mediaRecorderRef = useRef<MediaRecorder | null>(null);
    const audioChunksRef = useRef<Blob[]>([]);
    const { addToast } = CustomToast();
    const [text, setText] = useState("");
    const [listening, setListening] = useState(false);
    const [audioBlob, setAudioBlob] = useState<Blob | null>(null);

    useEffect(() => {
        const SpeechRecognition =
            (window as any).SpeechRecognition ||
            (window as any).webkitSpeechRecognition;

        if (!SpeechRecognition) {
            console.error("Speech recognition not supported");
            return;
        }

        const recognition = new SpeechRecognition();
        recognition.continuous = true;
        recognition.interimResults = true;
        recognition.lang = "en-US";

        recognition.onresult = (event: any) => {
            let finalTranscript = "";

            for (let i = event.resultIndex; i < event.results.length; i++) {
                if (event.results[i].isFinal) {
                    finalTranscript += event.results[i][0].transcript + " ";
                }
            }

            setText(prev => prev + finalTranscript);
        };

        recognitionRef.current = recognition;
    }, []);

    // const start = async () => {
    //     setText("");
    //     setAudioBlob(null);
    //     audioChunksRef.current = [];

    //     // 🎤 Get microphone access
    //     const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

    //     // 🎙️ Start audio recording
    //     const mediaRecorder = new MediaRecorder(stream);
    //     mediaRecorderRef.current = mediaRecorder;

    //     mediaRecorder.ondataavailable = (event) => {
    //         if (event.data.size > 0) {
    //             audioChunksRef.current.push(event.data);
    //         }
    //     };

    //     mediaRecorder.onstop = () => {
    //         const blob = new Blob(audioChunksRef.current, {
    //             type: "audio/webm"
    //         });
    //         setAudioBlob(blob);
    //     };

    //     mediaRecorder.start();
    //     recognitionRef.current?.start();
    //     setListening(true);

    // };

    const start = async () => {
        try {
            setText("");
            setAudioBlob(null);
            audioChunksRef.current = [];

            const stream = await navigator.mediaDevices.getUserMedia({
                audio: true,
            });

            const mediaRecorder = new MediaRecorder(stream);
            mediaRecorderRef.current = mediaRecorder;

            mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    audioChunksRef.current.push(event.data);
                }
            };

            mediaRecorder.onstop = () => {
                const blob = new Blob(audioChunksRef.current, {
                    type: "audio/webm",
                });
                setAudioBlob(blob);
            };

            mediaRecorder.start();
            recognitionRef.current?.start();
            setListening(true);
        } catch (error: any) {
            addToast({
                message:
                    error?.name === "NotAllowedError"
                        ? "Microphone permission denied. Please allow microphone access."
                        : "Unable to access microphone.",
                status: "error",
            });

            setListening(false);
        }
    };

    const stop = () => {
        recognitionRef.current?.stop();
        mediaRecorderRef.current?.stop();
        setListening(false);
    };

    // 📁 Convert Blob → File (for upload)
    const audioFile = audioBlob
        ? new File([audioBlob], "speech.webm", { type: "audio/webm" })
        : null;

    return { text, listening, start, stop, setText, audioBlob, audioFile };
};